module.exports = __webpack_public_path__ + "img/intro_uk.a10dced2.svg";